import { Visibility } from "@mui/icons-material";
import CommonAutocomplete from "../../../../../components/CommonAutocomplete";
import IntersectionObservedView from "../../../../../components/IntersectionObservedView";

function ProductClassSelect({value, productClasses, onSelect, ...prop}) {

  return (
    <IntersectionObservedView
      rootMargin = "50px"
    >
      <CommonAutocomplete
        value={value}
        onSelect={(_e, value) => {
          onSelect(value)
        }}
        data={productClasses}
        filterOptions={(options, { inputValue }) => {
          return options.filter((option) => {
            return option.productClassId?.toString().includes(inputValue);
          });
        }}
        optionLabel={(option) =>
          option ? option.productClassId + " - " + option.productClassName : ""
        }
        {...prop}
      />
    </IntersectionObservedView>
  );
}

export default ProductClassSelect;

